import React, { useEffect, useState } from 'react';

import Typography from '../../../../../components/Typography/Typography';
import Table from '../../../../../components/Table/Table';
import { useLoader } from '../../../../../hooks';
import classes from '../../../../../styles/AllDevices.module.css';
import { toast } from 'react-toastify';
import DeleteModal from '../../../../../components/DeleteModal/DeleteModal';
import { UserService } from '../../../../../services/UserService';
import { UilPen, UilTrash } from '@iconscout/react-unicons';
import { AdminService } from '../../../../../services/AdminService';
import { UilImport } from '@iconscout/react-unicons';
import IconComponent from '../../../../../components/Icon/Icon';
import adminClasess from '../../Admin.module.css';
import { exportData } from '../../../../../utils/downloadHelper';

function AdminUser({ adminId, setSelectedIndex, setCreateEditUser }) {
    const [startLoader, stopLoader] = useLoader();
    const [users, setUsers] = useState([]);
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        userId: '',
    });

    useEffect(() => {
        if (adminId) {
            fetchUsersById();
        }
    }, []);

    const fetchUsersById = () => {
        AdminService.GetUsers(adminId, startLoader, handleFetchSucess, handleError, stopLoader);
    };
    const handleFetchSucess = ({ data }) => {
        let newData = data.data.map((item, index) => ({
            sno: index + 1,
            name: item.name,
            email: item.email,
            role: item.userRole,
            contact: item.contact ? `${item.countryCode ? item.countryCode : ''} ${item.contact}` : '--',
            action: (
                <div
                    style={{
                        display: 'flex',
                        gridColumnGap: '1vw',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <UilPen
                            size={'1.2vw'}
                            style={{ color: 'var(--color-primary)' }}
                            onClick={() => {
                                setCreateEditUser({ status: true, data: item, adminId: null });
                                setSelectedIndex(1);
                            }}
                        />
                    </div>
                    <div>
                        <UilTrash size={'1.2vw'} style={{ color: 'var(--color-primary)' }} onClick={() => setDeleteModal({ status: true, userId: item._id })} />
                    </div>
                </div>
            ),
        }));
        setUsers(newData);
    };

    const handleDelete = () => {
        UserService.Delete(deleteModal.userId, startLoader, handleDeleteSuccess, handleError, stopLoader);
    };

    const handleDeleteSuccess = (res) => {
        if (res) {
            toast.success('User deleted successfully!');
            setDeleteModal({ status: false, userId: '' });
            fetchUsersById();
        }
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const downloadData = () => {
        exportData(users, 'Users', ['name', 'email', 'role', 'contact']);
    };

    return (
        <div className={classes.AllDevices} style={{ padding: '0' }}>
            <DeleteModal
                deletefunction={handleDelete}
                opendeleteModal={deleteModal.status}
                setOpenDeleteModal={(status) => setDeleteModal({ ...deleteModal, status })}
            ></DeleteModal>
            <div className={classes.Header}>
                <div>
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={users.length} />
                        </span>
                    </div>
                </div>
                <div className={adminClasess.UserHeader}>
                    <div className={classes.Button}>
                        <button
                            style={{ marginTop: '0' }}
                            className="btn-primary"
                            onClick={() => {
                                setCreateEditUser({ status: true, adminId, data: {} });
                                setSelectedIndex(1);
                            }}
                        >
                            Create User
                        </button>
                    </div>
                    <div style={{ marginTop: '0.5vh' }} onClick={() => downloadData()}>
                        <IconComponent icon={UilImport} tooltip={'Download'} size="1.5vw" />
                    </div>
                </div>
            </div>
            <div>
                <Table head={['S.No', 'Email', 'Contact', 'Role', 'Action']} keys={['sno', 'email', 'contact', 'role', 'action']} data={users} />
            </div>
        </div>
    );
}

export default AdminUser;
